import React from 'react';
import { Button } from '../../../../components/shared';

interface ErrorStateProps {
  title?: string;
  message?: string;
  onRetry?: () => void;
  retryText?: string;
  className?: string;
}

/**
 * Component for displaying error state
 */
export const ErrorState: React.FC<ErrorStateProps> = ({
  title = 'Ошибка загрузки данных',
  message,
  onRetry,
  retryText = 'Попробовать снова',
  className = '',
}) => {
  return (
    <div
      className={`min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50 pb-20 flex items-center justify-center ${className}`}
    >
      <div className="text-center">
        <div className="text-red-500 text-4xl mb-4">⚠️</div>
        <p className="text-gray-600 mb-4">{title}</p>
        {message && <p className="text-gray-500 mb-4">{message}</p>}
        {onRetry && <Button onClick={onRetry}>{retryText}</Button>}
      </div>
    </div>
  );
};
